<template>
    <div class="drawer drawer-right drawer-opportunity-create dw-xs-10 dw-sm-6 dw-md-3 fold" aria-labelledby="drawer-opportunity-create">
        <div class="drawer-contents">

            <div class="drawer-heading">
                <h2 class="drawer-title">
                    {{title}}
                </h2>
                <a href=".drawer-opportunity-create" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-opportunity-create" class="btn btn-close-drawer">
                    <i class="far fa-times"></i>
                </a>
            </div><!-- /.drawer-heading -->

            <div class="drawer-body">

                <div class="form-group form-group-material">
                    <label class="control-label">Opportunity Name</label>
                    <input
                            name="name"
                            v-model="newOpportunity.name"
                            type="text"
                            class="form-control"
                            data-vv-validate-on="input|blur"
                            data-vv-as="name"
                            v-validate="'required'"
                    />
                    <help-block field="name"/>
                </div>

                <div class="form-group form-group-material">
                    <label class="control-label">Type</label>
                    <multiselect :show-labels="false" v-model="newOpportunity.lead_type" :options="types" v-validate="'required'" data-vv-name="type"></multiselect>
                    <help-block field="type"/>
                </div><!-- /.form-group -->


                <div class="form-group form-group-material">
                    <label class="control-label">Due Date</label>
                    <input
                            name="due_date"
                            v-model="newOpportunity.due_date"
                            type="date"
                            class="form-control"
                    />
                    <help-block field="due_date"/>
                </div>

                <!-- <div class="form-group form-group-material">
                    <label class="control-label">Type</label>
                    <multiselect :show-labels="false" v-model="newOpportunity.lead_type" :options="types" v-validate="'required'" data-vv-name="type"></multiselect>
                    <help-block field="type"/>
                </div> -->

                <div class="form-group form-group-material">
                    <label class="control-label">Select Client</label>
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fal fa-fw fa-building"></i></span>
                        <div class="flex-grow-1">
                            <multiselect :show-labels="false" v-model="client" :options="clients" label="display_name" track-by="id" placeholder="" v-validate="'required'" data-vv-name="client" @select="clientSelected"  >
                                <template slot="beforeList">
                                    <a href=".drawer-client-create" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-contact">
                                        Add New Client
                                    </a>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <help-block field="client"/>
                </div><!-- /.form-group -->

                <div class="form-group form-group-material"  v-if="client">
                    <label class="control-label">Select Contact</label>
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fal fa-fw fa-address-card"></i></span>
                        <div class="flex-grow-1">
                            <multiselect :show-labels="false" v-model="contact" :options="contacts" label="name" track-by="id" placeholder="" v-validate="'required'" data-vv-name="contact" @select="contactSelected"  >
                                <template slot="beforeList">
                                    <a href=".drawer-contact" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-contact">
                                        Add Contact
                                    </a>
                                </template>
                                <template slot="singleLabel" slot-scope="props"><span class="option__title">{{ props.option.name }}</span><span class="option__small">{{ props.option.email }}</span></template>
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc"><span class="option__title">{{ props.option.name }}</span><span class="option__small">{{ props.option.email }}</span></div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <help-block field="contact"/>
                </div><!-- /.form-group -->

                <div class="form-group form-group-material">
                    <label class="control-label">Owner</label>
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fal fa-fw fa-user"></i></span>
                        <div class="flex-grow-1">
                            <multiselect :show-labels="false" v-model="user" :options="users" label="name" track-by="id" placeholder="Select Owner" v-validate="'required'" data-vv-name="user" @select="ownerSelected"  ></multiselect>
                        </div>
                    </div>
                    <help-block field="user"/>
                </div><!-- /.form-group -->

                <div class="row">
                    <div class="col-6 form-group form-group-material">
                        <label class="control-label">Expected</label>
                        <small class="form-text text-muted">Expected signing date</small>
                        <input
                                name="expected"
                                v-model="newOpportunity.expected"
                                type="date"
                                class="form-control"
                        />
                    </div>
                    <div class="col-6 form-group form-group-material">
                        <label class="control-label">Confidence</label>
                        <small class="form-text text-muted">&nbsp;</small>
                        <div class="input-group">
                            <input
                                    name="name"
                                    v-model="newOpportunity.confidence"
                                    type="number"
                                    class="form-control"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon1">%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 form-group form-group-material">
                        <label class="control-label">Client Budget</label>
                        <small class="form-text text-muted">Are we working within a budget?</small>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">$</span>
                            </div>
                            <input
                              @input="updateBudgetValues"
                              name="name"
                              v-model="newOpportunity.client_budget"
                              type="number"
                              class="form-control pl-2"
                            />
                        </div>
                    </div>
                    <div class="col-6 form-group form-group-material">
                        <label class="control-label">Potential Value</label>
                        <small class="form-text text-muted">Complete project potential value.</small>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">$</span>
                            </div>
                            <input
                              name="name"
                              v-model="newOpportunity.project_value"
                              type="number"
                              class="form-control pl-2"
                            />
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-6 form-group form-group-material">
                    <label class="control-label">License Fee</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">$</span>
                      </div>
                      <input
                      readonly
                      disabled
                        name="name"
                        v-model="newOpportunity.license_fee"
                        type="number"
                        class="form-control pl-2"
                      />
                    </div>
                  </div>
                  <div class="col-6 form-group form-group-material">
                    <label class="control-label">Margin <small></small></label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">$</span>
                      </div>
                      <input
                        readonly
                        disabled
                        name="name"
                        v-model="newOpportunity.margin"
                        type="number"
                        class="form-control pl-2"
                      />
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <p><small>Budget for scoping:</small> <span :class="{ 'text-danger': scopingBudget < 50000  }">${{ scopingBudget | currency0 }}</span></p>
                    <p><small>Budget for development:</small> <span :class="{ 'text-danger': deliveryBudget < 50000  }">${{ deliveryBudget | currency0 }}</span></p>
                  </div>
                </div>


                <button type="button" class="btn btn-rounded btn-default" data-toggle="drawer" data-target=".drawer-opportunity-create" aria-foldedopen="false" aria-controls="drawer-opportunity-create">Cancel</button>
                <ladda-button :on-click="handleSaveOpportunity" class="btn btn-rounded btn-primary">Save</ladda-button>

            </div><!-- /.drawer-body -->

        </div><!-- /.drawer-contents -->
    </div><!-- /.drawer -->

</template>

<style>
    .form-control {
        box-shadow: none !important;
    }

    .form-control[readonly] {
        background-color: transparent !important;
    }
</style>

<script>

    import { mapActions, mapState, mapGetters } from 'vuex'
    import { http } from 'utils'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import $ from 'jquery'
    import { notify } from 'utils'
    import { unset, cloneDeep } from 'lodash'
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'
    import { helperMethods } from 'vx/modules/clients'

    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: ['title', 'opportunity'],
        components: {
            Selectize,
            LaddaButton,
            Datepicker,
            Multiselect
        },

        data() {
            return {
                newOpportunity: {},
                types: ['Stage 1', 'Stage 2', 'Stage 3', 'Stage 1 & 2', 'Variation', 'Full Budget', 'T&M', 'Consult', 'Template'],
                client: null,
                contact: null,
                user: null,
                margin: 0.15
            }
        },

         mounted() {

            this.getClients()
            this.getUsers()

            $('.drawer-opportunity-create').on('show.bs.drawer', () => {
                 this.newOpportunity =  cloneDeep(this.opportunity)

                if (this.newOpportunity.client_id) {
                    this.client = this.getClientById(this.newOpportunity.client_id)

                    this.getContacts(this.newOpportunity.client_id).then(() => {
                        this.contact = this.getContactById(this.newOpportunity.contact_id)
                    })

                    this.user = this.getUserById(this.newOpportunity.user_id)
                }
            });

            this.$bus.$on('newClientCreated', (clientId) => {
                 this.getClients().then(() => {
                    this.client = this.getClientById(clientId)
                    this.newOpportunity.client_id = clientId

                    //Auto select first contact when new client is created
                    this.getContacts(clientId).then(() => {
                        this.contact = this.getContactById(this.contacts[0].id)
                        this.newOpportunity.contact_id = this.contact.id
                    })
                })
            })

            this.$bus.$on('newContactCreated', (contactId) => {
                 this.getContacts(this.newOpportunity.client_id).then(() => {
                    this.contact = this.getContactById(contactId)
                    this.newOpportunity.contact_id = this.contact.id
                })
            })
        },

        computed: {
            ...mapState('contacts', ['contacts']),
            ...mapState('contacts', ['client_id']),
            ...mapState('clientsList', ['clients']),
            ...mapState('users', ['users']),
            ...mapGetters('clientsList', {getClientById: 'getById'}),
            ...mapGetters('contacts', {getContactById: 'getById'}),
            ...mapGetters('users', {getUserById: 'getById'}),

            calculatedMargin() {
              return 0
            },

            scopingBudget() {
              var scopingBudget = this.newOpportunity.client_budget*0.2
              return (scopingBudget/1.10)
            },

            deliveryBudget() {
              var devBudget = this.newOpportunity.client_budget*0.8
              return (devBudget/1.15) - (this.newOpportunity.license_fee)
            }
        },


        methods: {
            ...helperMethods,
            ...mapActions('opportunity', ['addSingle', 'updateSingle']),
            ...mapActions('clientsList', ['getClients']),
            ...mapActions('users', ['getUsers']),
            ...mapActions('contacts', ['getContacts']),
            ...mapActions('client', ['setClient']),

            updateBudgetValues () {
              //70% is the extimated percentage of the budget being development
              var devBudget = this.newOpportunity.client_budget * 0.8
              var scopingBudget = this.newOpportunity.client_budget * 0.2
              this.newOpportunity.license_fee = Math.max(20000, (devBudget - (devBudget/1.25))).toFixed()
              this.newOpportunity.margin = ((devBudget - (devBudget/1.1)) + ((scopingBudget)/1.1)).toFixed()
            },

            clientSelected(selected) {
                this.newOpportunity.client_id = selected.id
                //Ensure no contact is selected from a previous client selection
                this.contact = null;
                this.getContacts(selected.id);
            },

            ownerSelected(selected) {
                this.newOpportunity.user_id = selected.id
            },

            contactSelected(selected) {
                this.newOpportunity.contact_id = selected.id
            },

            typeSelected(selected) {
                this.newOpportunity.lead_type = selected.id
            },

            handleSaveOpportunity() {
                if (this.newOpportunity.id) {
                    return this.handleUpdateOpportunity();
                } else {
                    return this.handleAddOpportunity();
                }
            },

            async handleAddOpportunity() {

                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                try {

                    return this.addSingle(this.newOpportunity).then((response) => {
                        //Redirect to new opp
                        this.$router.push({ name: 'opportunities.overview', params: { opportunity_id: response.data.data.id } })
                    }).catch((error) => {
                        if (error.response.status === 422) {
                            notify.error('Form validation failed, please check your inputs and try again.')
                        } else {
                            console.error(error);
                            notify.error('Failed to create opportunity, please try again.')
                        }
                    })
                }
                catch(error) {
                    console.error(error);
                }
            },

            async handleUpdateOpportunity() {

                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                try {

                    return this.updateSingle({id:this.newOpportunity.id, payload:this.newOpportunity}).then((response) => {
                        //Redirect to new opp
                        //this.$router.push({ name: 'opportunities.show', params: { opportunity_id: response.data.id } })

                        //In case client was changed, refresh the state from the api repsonse
                        this.setlient(response.data.data.client)

                        notify.success('Opportunity successfuly updated.')
                        $('.drawer-opportunity-create').drawer('hide')


                    }).catch((error) => {
                        if (error.response.status === 422) {
                            notify.error('Form validation failed, please check your inputs and try again.')
                        } else {
                            console.error(error);
                            notify.error('Failed to create opportunity, please try again.')
                        }
                    })
                }
                catch(error) {
                    console.error(error);
                }
            },
        }
    }
</script>
